import Realplay from './containers/RealPlay';
import RealPlayQualified from './containers/RealPlayQualified';
import RealPlaySubmit from './containers/RealPlaySubmit';
import SubmitReviewRealplay from './Components/SubmitReviewRealplay/SubmitReviewRealplay';
import pageLayoutHoc from 'hocs/pageLayoutHoc';

export const realPlayRoutes = [
  {
    path: '/realplay/:uuid',
    component: pageLayoutHoc(Realplay),
    key: 'realplay-view',
  },
  {
    path: '/realplay-review-qualified/:uuid',
    component: pageLayoutHoc(RealPlayQualified),
    key: 'roleplay-review',
  },
  {
    path: '/realplay/:uuid/submit',
    component: pageLayoutHoc(RealPlaySubmit),
    key: 'roleplay-view',
  },
  {
    path: '/realplay-review/:uuid/submit',
    component: pageLayoutHoc(SubmitReviewRealplay),
    key: 'roleplay-review',
  },
];
